export { default } from './SpotPageMiddleAd';
